import React from 'react';
import './style.sass';
import toocanImg from '../../assets/img/toocan.png';

const Watermark = () => {
  // 创建多个水印位置，覆盖整个页面
  const watermarkPositions = [
    { top: '20%', left: '15%' },
    { top: '20%', left: '70%' },
    { top: '50%', left: '10%' },
    { top: '50%', left: '75%' },
    { top: '80%', left: '20%' },
    { top: '80%', left: '65%' },
  ];

  return (
    <div className="watermark-container">
      {watermarkPositions.map((position, index) => (
        <div
          key={index}
          className="watermark-item"
          style={{ top: position.top, left: position.left }}
        >
          <img src={toocanImg} alt="BEEC" className="watermark-image" />
          <span className="watermark-text">BEEC</span>
        </div>
      ))}
    </div>
  );
};

export default Watermark;

